import Vue from 'vue'
import { VIcon } from 'vuetify/lib'
import { useInstructionsModal } from '../Providers/InstructionsModalProvider/useInstructionsModal'

export const InputLabel = Vue.extend({
	name: 'InputLabel',
	props: {
		label: { type: String, default: '' },
		for: { type: String, default: '' },
		required: { type: Boolean, default: false },
		instructions: { type: String, default: '' },
		hint: { type: String, default: '' },
		noRequiredText: { type: Boolean, default: false }
	},

	computed: {
		requiredText(): string {
			return this.required && !this.noRequiredText ? '(Obrigatório)' : '' //"(Opcional)"
		}
	},

	methods: {
		showDialog() {
			const dialog = useInstructionsModal()
			dialog.show(this.instructions)
		}
	},

	render() {
		return (
			<div>
				<label for={this.for} class="app--input-base__default-label">
					{this.label}
					<span class="app--input-base__required mx-2">{this.requiredText}</span>
					{this.instructions ? (
						<button onClick={() => this.showDialog()}>
							<VIcon size="18" color="primary">
								mdi-information-outline
							</VIcon>
						</button>
					) : (
						''
					)}
				</label>
				<div class="app--input-base__caption">{this.hint}</div>
			</div>
		)
	}
})

export default InputLabel
